import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface StaticsProps {
    courseStuCount: number;
    voteStuCount: number;
    notVoteStuCount: number;
    current: string;
    onChange: (select: string) => void;
}

export default function Statics({
    courseStuCount,
    voteStuCount,
    notVoteStuCount,
    current,
    onChange
}: StaticsProps) {
    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "all"
                })}
                onClick={() => onChange("all")}>
                <em>{courseStuCount}</em>课程人数
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "vote"
                })}
                onClick={() => onChange("vote")}>
                <em>{voteStuCount}</em>已投票
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "unVote"
                })}
                onClick={() => onChange("unVote")}>
                <em>{notVoteStuCount}</em>未投票
            </div>
        </div>
    );
}
